const Home = {

    init(){
        this.el = $('[page="home"]');
        if(!this.el.length) return;

        this.banners = this.el.find('[container="banners"] .holder');
		this.prepare();
    },

	prepare(){
		this.banners.each((i, el)=>{
			const url = $(el).find('[element="button"]').attr('href');
			$(el).click((evt)=>{
				evt.preventDefault();
				window.location.href = url;
			})
		})
	},
}

export default Home;